import { Box, Typography, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const AccessDenied = () => {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 900,
          height: 400,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          borderRadius: 1,
        }}>
        {/* Icon Circle */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            border: '2px solid',
            borderColor: 'grey.300',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}>
          <LockOutlinedIcon sx={{ fontSize: 36, color: 'grey.500' }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            mb: 1.5,
          }}>
          ACCESS REQUIRED
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            maxWidth: 500,
          }}>
          You do not have access to this App.
          <br />
          This page will unlock once it’s enabled.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
